enum ValidationProperties {
	ACCOUNT_MANAGER = 'accountManager',
	LISTING_BUDGET = 'listingBudget',
	CAMPAIGN_TYPE = 'campaignType',
	CLIENT_SERVICES_PERSON = 'clientServicesPerson',
	CRM_ID = 'crmId',
	CURRENCY = 'currency',
	DELIVERY_MODE = 'deliveryMode',
	END_DATE = 'endDate',
	NAME = 'name',
	PARTNERSHIP_TYPE = 'partnershipType',
	REGION = 'region',
	START_DATE = 'startDate',
	CUSTOM_PRODUCTS_BUDGET = 'customProductsBudget'
}

interface IValidationInfoDates {
	message: string;
	invalidTypes: ValidationProperties[];
}

export { ValidationProperties, IValidationInfoDates };
